import { isLastCompleteWeekOfMonth } from "../util/format";

const OrderTypeSelector = () => {
    return (
        <div className="col-md-12 mb-2">
            <div className="row">
                <div className="col-12 mb-3 text-center">
                    <div
                        className="rounded py-2 text-uppercase bg-primary text-white w-100"
                        style={{ fontSize: 16 }}
                    >
                        {isLastCompleteWeekOfMonth() ? 'Mensual' : 'Extraordinario'}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OrderTypeSelector